module.exports = __webpack_public_path__ + "static/media/narciso-rodriguez.c0daf15c.jpg";